import Vue from "vue";

const mixin = {
  data() {
    return {
    };
  },
  //自定義指令
  directives: {
    boxOutsideClose: {
      bind: function (el, binding) {
        const closeFunction = function (event) {
          //define the dom which after the click_dom
          const click_targe = event.target.nextSibling ? event.target.nextSibling : event.target
          if (!click_targe.contains(el) || click_targe !== el) {
            //run the defined function
            binding.value();
          }
        };
        //mount to the el in order to remove listener
        el['__vueEventListener__'] = closeFunction
        document.addEventListener('click', closeFunction)
      },
      unbind: function (el) {
        document.removeEventListener('click', el.__vueEventListener__);
      },
    },
  },
  computed: {
    is_router() {
      return this.$route.name;
    },
    is_role() {
      return this.$store.state.user.role
    }
  },
  methods: {
    isSort({ data, attr, type, object_depend }) {
      return data.sort((a, b) => {
        if (typeof a[attr] == "string" && a[attr].match(/^[0-9]*$/)) {
          //如果是字串的數字
          if (type == 'sort') {
            return a[attr] - b[attr];
          } else {
            return b[attr] - a[attr];
          }
        }
        else if (typeof a[attr] == 'object') {
          //如果是陣列、物件等型態
          if (Array.isArray(a[attr])) {
            if (type == 'sort') {
              return a[attr][0][object_depend] > b[attr][0][object_depend] ? 1 : -1;
            } else {
              return a[attr][0][object_depend] < b[attr][0][object_depend] ? 1 : -1;
            }
          } else {
            if (type == 'sort') {
              return a[attr][object_depend] > b[attr][object_depend] ? 1 : -1;
            } else {
              return a[attr][object_depend] < b[attr][object_depend] ? 1 : -1;
            }
          }
        }
        else {
          //一般
          if (type == 'sort') {
            return a[attr] > b[attr] ? 1 : -1;
          } else {
            return a[attr] < b[attr] ? 1 : -1;
          }
        }

      })
    },
    mustField({ key, data }) {
      return key.filter(el => {
        return !data[el] || data[el].length == 0
      })
    },
    returnLogin() {
      //this.$router.go(-1);
      this.$router.back(-1);
    },
    link(item) {
      const num = Math.floor(Math.random() * 10);
      //console.log(`${this.$http.base.storage}${item}?v=${num}`);
      window.open(`${this.$http.base.storage}${item}?v=${num}`, "_blank")
    },
    blankLink(link, params) {
      // console.log('link:',link);
      // console.log('param:',params);
      console.log(this.$router.resolve({
        name: link,
        query: params
      }));
      const { href } = this.$router.resolve({
        name: link,
        query: params
      });
      window.open(href, "_blank");
    },
    defaultRouter(link, params) {
      //console.log(link,params);
      this.$router.push({
        name: link,
        query: params
      })
    },
    goAdd(path, type) {
      this.$router.push({
        name: path,
        query: {
          type: type,
        },
      });
    },



  },
};
Vue.mixin(mixin)
export default mixin;
